module.exports = __webpack_public_path__ + "static/media/20201216_201302_541_IMG_3190.f15358f2.jpg";